import React, { useCallback } from 'react';
import styles from './index.module.scss';
import { CnMessage, CnDialog } from '@sto/cn-ui';
import { request } from '@/api/request';
import CForm from '../chatComponents/CForm';

/**
 * 操作按钮组
 * @param props
 * @returns
 */
const Operation = (props) => {
  const { buttons, requestId } = props;

  const handleClick = useCallback((item) => {
    const { schema, remoteConfig} = item;
    const { url, method, params } = remoteConfig || {};
    if (remoteConfig &&url) {
      request({ url, method, data: params, }).then(res => {
        if (res.success) {
          CnMessage.success(res.data);
        } else {
          CnMessage.error(res.errMessage);
        }
      });
    } else if (schema) {
      const dialog = CnDialog.show({
        title: '创建订阅任务',
        content: <CForm 
          content={schema} 
          taskType={null} 
          askQuestion={null} 
          isHistory={false} 
          onSuccessCallback={() => {
            dialog.hide();
          }}
          formContentStyle={{ maxHeight: '500px', overflow: 'auto' }} 
          // requestId={requestId} // 20250826 新程说：会话里的定义按钮不传requestId
        />,
        width: 660,
        className: styles.operationDialog,
        footer: false,
      });
    } else {
      CnMessage.error('按钮没有相应的操作配置');
    }
  }, [requestId]);

  if (!buttons?.length) {
    return null;
  }

  return (
    <div className={`${styles.operation}`}>
      <div className={styles.operationBox}>
        {buttons?.map((item, index) => {
          return <div key={index} className={styles.operationItem} onClick={() => handleClick(item)}>
              <span>{item.title}</span>
            </div>
        })}
      </div>
    </div>
  );
};

export default Operation;
